/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { getDistance } from 'geolib';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const ShopList = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [list, setList] = useState([]);
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);

    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);

    const navigate = useNavigate();
    const Categoreyid = sessionStorage.getItem("Catid");


    useEffect(() => {
        window.scrollTo(0, 0);

        navigator.geolocation.getCurrentPosition(position => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            setLatitude(lat);
            setLongitude(long);
            fetchHomeData(lat, long, 1);
        });
    }, []);

    const fetchHomeData = (lat, long, page) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/store_list`, { uid: Userid, category_id: Categoreyid, lat: lat, lon: long, page })
                .then((res) => {
                    const { ResponseCode, store_list } = res.data;
                    if (ResponseCode === 200) {
                        if (store_list.length === 0) NoMoreDataRef.current = false;
                        setLoading(false);
                        setList(page === 1 ? store_list : [...list, ...store_list]);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;
        fetchHomeData(latitude, longitude, page);
    }, [page])

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prevPage => prevPage + 1);
            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    const HandleDistance = (lat1, long1, lat2, long2) => {
        const distance = getDistance(
            { latitude: lat1, longitude: long1 },
            { latitude: lat2, longitude: long2 }
        );

        const Tofixed = (distance / 1000).toFixed(2);

        return Tofixed;
    };

    const HandleNavigate = (Docid) => {
        navigate("/store-home");
        sessionStorage.setItem("Docdetails", JSON.stringify({ Categoreyid, Docid }));
    };

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='width-container pb-[50px] content-wrapper'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="flex items-center justify-between top-section">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px]">
                            <Link to="/shop" className='font-[500] text-gray-700'>{t("Shop")}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{t("Shop List")}</h1>
                        </div>
                    </div>

                    <div className="mt-[30px] flex flex-wrap items-center gap-[20px] lab-details">
                        {list.length >= 1
                            ? list.map((item, index) => {
                                return <div onClick={() => HandleNavigate(item.id)} key={index} className="card-box">
                                    <div className="">
                                        <img className='photo' src={ImgBaseUrl + item.image} alt="Logo" />
                                    </div>
                                    <div className="p-[10px]">
                                        <h1 className='text-[18px] font-[500]'>{item.name}</h1>
                                        <p className='leading-[18px] text-[15px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.address}</p>
                                        <div className='text-[16px] font-[500] flex items-center gap-[5px]'>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V13C14.75 14.2426 15.7574 15.25 17 15.25H18C20.0711 15.25 21.75 16.9289 21.75 19C21.75 21.0711 20.0711 22.75 18 22.75H10C9.58579 22.75 9.25 22.4142 9.25 22C9.25 21.5858 9.58579 21.25 10 21.25H18C19.2426 21.25 20.25 20.2426 20.25 19C20.25 17.7574 19.2426 16.75 18 16.75H17C14.9289 16.75 13.25 15.0711 13.25 13V11C13.25 10.5858 13.5858 10.25 14 10.25ZM6 12C8.20914 12 10 13.7909 10 16C10 18.2091 8 22 6 22C4 22 2 18.2091 2 16C2 13.7909 3.79086 12 6 12ZM6 14.5C5.17157 14.5 4.5 15.1716 4.5 16C4.5 16.8284 5.17157 17.5 6 17.5C6.82843 17.5 7.5 16.8284 7.5 16C7.5 15.1716 6.82843 14.5 6 14.5ZM14 2C15.6569 2 17 3 17 5C17 6.12295 16.0541 7.56102 15.2246 8.60645C14.5741 9.4263 13.3839 9.47071 12.7031 8.67578C11.892 7.72862 11 6.41344 11 5.20898C11.0001 2.99995 12.3432 2 14 2ZM14 4C13.4477 4 13 4.44772 13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4Z" fill="#28303F" />
                                            </svg>
                                            <h1 className='text-gray-700'>{HandleDistance(latitude, longitude, item.latitude, item.longitude)} Km</h1>
                                        </div>
                                    </div>
                                </div>
                            })
                            : <div className='w-[100%] h-[300px] flex items-center justify-center'>
                                <h1 className='font-[500] text-[20px] text-center'>{t("No Stroe available in")} <br /> {t("your area.")}</h1>
                            </div>}
                    </div>
                </div>}
        </div>
    )
}

export default ShopList
/* jshint ignore:end */